// This browser's own random id, sent to the API as X-Client-Device, so a person's second
// free account on the same phone is told apart from a new person
// (backend/api/api/services/devices.py). Kept across sign-outs; null when storage is blocked.
const KEY = 'app.device';
const VALID = /^[A-Za-z0-9-]{16,64}$/;

let cached;

function randomId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
}

export function deviceId() {
  if (cached !== undefined) return cached;
  try {
    let id = window.localStorage.getItem(KEY);
    if (!id || !VALID.test(id)) {
      id = randomId();
      window.localStorage.setItem(KEY, id);
    }
    cached = id;
  } catch {
    cached = null;
  }
  return cached;
}

export function resetDeviceIdForTests() {
  cached = undefined;
}
